module.exports = __webpack_public_path__ + "img/c-a.4f7ad13b.png";